<div class="content h-100">
  <NavBar />
  <v-main>
    <v-container fluid>
      <v-card class="bg-white pa-5" :elevation="2">
        <div class="d-flex justify-space-between">
          <div>
            <div class="d-flex">
              <v-icon size="x-large">mdi-format-list-bulleted</v-icon>
              <div class="ml-3 text-h4">
                Formularios Campaña > {{ campaing }}
              </div>
            </div>
            <div>
              Gestión de campañas y formularios de donaciones.
            </div>
          </div>
        </div>
        <div class="mt-3">
          <div>
            <FormsCharts />
          </div>
          <div class="mt-3">
            <FormsList v-on:titlecampaing="setcampaing"/>
          </div>
        </div>
      </v-card>
    </v-container>
  </v-main>
</div>